import Swiper, { Navigation } from "swiper";

const setOverviewSlider = () => {
  const targets = document.querySelectorAll('.js-overview-slider')
  if (!targets.length) return false;

  targets.forEach(target => {
    const slides = target.querySelectorAll('.swiper-slide');
    if (slides.length > 1) {
      const prev = target.querySelector('.overview-slider-nav__prev'),
        next = target.querySelector('.overview-slider-nav__next');
      const swiper = new Swiper(target, {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1,
        centeredSlides: false,
        speed: 400,
        navigation: {
          prevEl: prev,
          nextEl: next,
        }
      });

      prev?.classList.add('is-show');
      next?.classList.add('is-show');
    }

    target.classList.add('is-init')
  })

};

export default setOverviewSlider;